import { PanelRightClose, Filter, Plus } from 'lucide-react'

interface AssetsPanelProps {
  onClose?: () => void
}

export default function AssetsPanel({ onClose }: AssetsPanelProps) {
  return (
    <div className="flex w-72 flex-col rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center justify-between px-4 py-3">
        <h2 className="font-semibold text-gray-900">Assets</h2>
        <button
          onClick={onClose}
          className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        >
          <PanelRightClose className="h-4 w-4 rotate-180" />
        </button>
      </div>

      <div className="flex items-center gap-2 px-4 pb-2">
        <button className="rounded-lg bg-gray-900 px-3 py-1.5 text-xs font-medium text-white shadow-sm">
          Media
        </button>
        <button className="rounded-lg px-3 py-1.5 text-xs font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-900">
          Doc
        </button>
        <div className="flex-1" />
        <button className="rounded p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600">
          <Filter className="h-4 w-4" />
        </button>
      </div>

      <div className="custom-scrollbar flex-1 overflow-y-auto p-4">
        <div className="grid grid-cols-2 gap-3">
          {[
            'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=400&h=225&fit=crop',
            'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=400&h=225&fit=crop',
            'https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=400&h=225&fit=crop',
            'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=400&h=225&fit=crop',
            'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=400&h=225&fit=crop',
            'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=400&h=225&fit=crop',
          ].map((url, i) => (
            <div
              key={i}
              className="group relative aspect-video cursor-pointer overflow-hidden rounded-lg bg-gray-100 ring-1 ring-black/5 transition-all hover:ring-2 hover:ring-blue-500/50"
            >
              <img
                src={url}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                alt="Asset"
              />
              <span className="absolute bottom-1 right-1 rounded bg-black/60 px-1 text-[10px] font-medium text-white backdrop-blur-sm">
                00:06
              </span>
            </div>
          ))}
          <div className="flex aspect-video cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 text-gray-400 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-500">
            <Plus className="h-6 w-6" />
          </div>
        </div>
      </div>
    </div>
  )
}
